import React, { useRef, useState } from "react"
import { Button, Col, Form, Label, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { useSelector } from "react-redux"
import { isObject } from "lodash"
import Select from "react-select"

const ProviderExpireReceiptFilter = ({ onAdvancedSearchSubmit, loading }) => {
  const expireFlatpickerfrom = useRef(null)
  const expireFlatpickerto = useRef(null)
  const receiptFlatpickerfrom = useRef(null)
  const receiptFlatpickerto = useRef(null)
  const [currency, setCurrency] = useState(null)
  const [expireDate, setExpireDate] = useState({
    from: null,
    to: null,
  })
  const [receiptDate, setReceiptDate] = useState({
    from: null,
    to: null,
  })

  // Retrieve currencies data from Redux store
  const currencies = useSelector(
    state => state.providerDashboard.ProviderCurrencies
  )

  // Store filtered data and dispatch the action using onAdvancedSearchSubmit callback function
  const handleSubmit = () => {
    let data = {}
    data.currency = isObject(currency) ? currency.value : null
    data.expireDate = {
      from: expireDate.from ? expireDate.from : null,
      to: expireDate.to ? expireDate.to : null,
    }
    data.receiptDate = {
      from: receiptDate.from ? receiptDate.from : null,
      to: receiptDate.to ? receiptDate.to : null,
    }
    onAdvancedSearchSubmit(data)
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    expireFlatpickerfrom.current.flatpickr.clear()
    expireFlatpickerto.current.flatpickr.clear()
    receiptFlatpickerfrom.current.flatpickr.clear()
    receiptFlatpickerto.current.flatpickr.clear()
    setCurrency(null)
    setExpireDate({ from: null, to: null })
    setReceiptDate({ from: null, to: null })
    onAdvancedSearchSubmit({})
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Currency</Label>
            {currencies?.data && (
              <Select
                options={currencies?.data}
                value={currency}
                onChange={value => setCurrency(value)}
              />
            )}
          </Col>
          <Col></Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">Expire From Date</Label>
            <Flatpickr
              ref={expireFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setExpireDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">Expire To Date</Label>
            <Flatpickr
              ref={expireFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setExpireDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">Receipt From Date</Label>
            <Flatpickr
              ref={receiptFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setReceiptDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">Receipt To Date</Label>
            <Flatpickr
              ref={receiptFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setReceiptDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderExpireReceiptFilter
